export type FaqCategory = "supplier" | "franchise" | "b2b" | "general";

export interface FaqEntry {
  q: string;
  a: string;
  category: FaqCategory;
}

// The 4 original entries' `q`/`a` text is left byte-for-byte unchanged —
// useChatbotEngine.ts's exact-title-match confidence tier and
// chatbotContent.ts's EXAMPLE_QUESTIONS both depend on this exact wording
// (see jira/ZP-89's capture for the bug this project already hit once from
// a mismatched paraphrase). New category-specific entries only ever
// describe ZenFresh's own real, self-controlled process — never a claim
// about a real third party — so they're freely authorable, same register
// as certifications.ts's practice copy.
export const FAQS: FaqEntry[] = [
  {
    q: "Which areas do you deliver to?",
    a: "We currently deliver across 12 coastal cities in India, with new regions added quarterly. Enter your PIN code at checkout to confirm coverage.",
    category: "general",
  },
  {
    q: "How is freshness guaranteed?",
    a: "Every order ships within hours of the catch, packed in ice by the same crew that caught it, and travels in a temperature-monitored cold chain.",
    category: "general",
  },
  {
    q: "Can I choose a specific fisherman or boat?",
    a: "Yes — each listing shows the partner fishery, and you can filter by region in your account preferences once you place your first order.",
    category: "general",
  },
  {
    q: "What if I'm not home for delivery?",
    a: "Orders arrive in insulated, ice-packed coolers that keep seafood fresh for several hours, so it's safe even if you're running late.",
    category: "general",
  },
  {
    q: "What compliance documents do I need to become a supplier?",
    a: "A GST registration (if applicable to your business), your FSSAI registration, and a boat or fishing licence. You can attach these directly on the Become a Supplier form — no need to email them separately.",
    category: "supplier",
  },
  {
    q: "How long does a supplier application take to review?",
    a: "Our Procurement team typically reviews new supplier applications within 3–5 business days of submission.",
    category: "supplier",
  },
  {
    q: "Is there a fee to become a ZenFresh franchise partner?",
    a: "Investment details and fee structure are discussed directly with our Business Development team once your enquiry is reviewed — this isn't published generally since it varies by city and format.",
    category: "franchise",
  },
  {
    q: "Can I open a franchise in a city you already serve?",
    a: "We prioritize franchise conversations in cities we haven't launched in yet. If you enquire about an already-served city, we'll flag that and suggest a nearby expansion target instead.",
    category: "franchise",
  },
  {
    q: "What's the minimum order volume for B2B pricing?",
    a: "There's no strict minimum to start a conversation — tell us your estimated monthly volume on the B2B enquiry form and our Corporate Sales team will work out pricing that fits.",
    category: "b2b",
  },
  {
    q: "Can I request a custom quote (RFQ)?",
    a: "Yes — attach your requirements document on the B2B enquiry form and our Corporate Sales team will follow up with a tailored quote.",
    category: "b2b",
  },
];
